export const surveyForm = [
    {
        path: 'survey_form/manager',
        component: () => import("@/views/survey_form/SurveyFormManager.vue")
    },
]